<script setup>
const businessStore = useBusinessStore()

const companyItems = computed(() => businessStore.companies.map(company => ({
  title: company?.companyName || company?.name || "مجموعه بدون نام",
  value: company?.companyId ?? company?.id,
})))

const selectedId = computed({
  get: () => businessStore.selectedCompanyId,
  set: value => businessStore.setCompany(value),
})
</script>

<template>
  <div class="business-context">
    <div class="business-context__icon"><VIcon icon="tabler-building-store" size="21" /></div>
    <VSelect
      v-if="businessStore.loading || companyItems.length"
      v-model="selectedId"
      :items="companyItems"
      :loading="businessStore.loading"
      :disabled="businessStore.loading"
      variant="plain"
      density="compact"
      placeholder="در حال دریافت مجموعه‌ها..."
      hide-details
      aria-label="انتخاب مجموعه فعال"
    />
    <div v-else class="business-context__empty">
      <strong>هنوز مجموعه‌ای نداری</strong>
      <NuxtLink to="/user-profile/company-registration">ثبت مجموعه</NuxtLink>
    </div>
  </div>
</template>

<style scoped lang="scss">
.business-context { display: flex; min-width: 230px; min-height: 48px; align-items: center; gap: 9px; padding: 5px 10px; border: 1px solid rgba(var(--v-theme-primary), .12); border-radius: 14px; background: #fff; }
.business-context__icon { display: grid; width: 36px; height: 36px; flex: 0 0 36px; place-items: center; border-radius: 11px; color: rgb(var(--v-theme-primary)); background: rgba(var(--v-theme-primary), .09); }
.business-context :deep(.v-field__input) { min-height: 36px; padding-block: 4px; font-size: 12px; font-weight: 700; }
.business-context :deep(.v-input) { flex: 1; min-width: 0; }
.business-context :deep(.v-field__loader) { color: rgb(var(--v-theme-primary)); }
.business-context__empty { display: flex; flex: 1; align-items: center; justify-content: space-between; gap: 8px; font-size: 11px; }
.business-context__empty a { color: rgb(var(--v-theme-primary)); font-weight: 800; }
@media (max-width: 599px) { .business-context { min-width: 0; width: 100%; } }
</style>
